import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from './../../types/entity';

export interface IBrandLogo extends IEntity {
  attributes: {
    id: EntityStringId;
    url: string;
  };
}

export type BrandLogo = Entity<IBrandLogo>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandLogo: IEntityType<IBrandLogo> = vmClient.defineClass({
  typeName: 'BrandLogo',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    url: {
      type: 'string',
      notNull: true,
    },
  },
});
